import React from "react";
import { BtnThemMoiMobile } from "./ThemMoi/BtnThemMoiMobile";

export const Headersub = ({ icon, title, quyenThemMoi }) => {
  return (
    <div className="breadcrumb-new mb-1">
      <div className="row">
        <div className="col-sm-12 col-md-12 title-cd">
          <div className="media-home align-center-home">
            <div class="row header">
              <img className="icon-bred-home" src={icon} alt="" />
              <h1 className="text-info-home">{title}</h1>
            </div>
          </div>{" "}
          <BtnThemMoiMobile quyenThemMoi={quyenThemMoi} />
        </div>{" "}
      </div>{" "}
    </div>
  );
};
